import { Container, LinearProgress } from '../../../UI'
import useStyles from './styles'
import { blueLogo } from '../../../../assets'
import { LoaderProps } from '../types'
import { FC } from 'react'

const PunchlistLoader: FC<LoaderProps> = ({ children, loading = true }) => {
  const classes = useStyles()

  if (children && !loading) {
    return <> {children} </>
  }

  return (
    <Container className={classes.content}>
      <img src={blueLogo} alt="" className={classes.logo} />
      <LinearProgress className={classes.loader} />
    </Container>
  )
}

export default PunchlistLoader
